import React from 'react';
import moment from 'moment';
import {
    Button,
    Select,
    Card,
    Row,
    Col,
    Radio,
    Input,
    DatePicker,
    Tooltip,
} from 'antd';
import {
    DeleteOutlined,
    PlusOutlined,
    MenuUnfoldOutlined,
} from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { isEmpty, isNotEmpty, dateTimeFormat } from '../Service/Utils';
import Icon from '@ant-design/icons';
const addAndOrLevelSvg = () => (<svg t="1646724335419" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2940" width="1em" height="1em"><path d="M46.545455 269.963636h93.090909v693.527273H46.545455z" p-id="2941" fill="#1890ff"></path><path d="M107.054545 870.4h144.29091v93.090909H107.054545zM772.654545 833.163636h232.727273v93.090909h-232.727273z" p-id="2942" fill="#1890ff"></path><path d="M842.472727 763.345455h93.090909v232.727272h-93.090909zM535.272727 311.854545H0V0h535.272727v311.854545zM93.090909 218.763636h349.090909V93.090909H93.090909v125.672727zM740.072727 1024H218.763636v-311.854545h521.309091V1024z m-432.872727-93.090909H651.636364v-125.672727H307.2V930.909091z" p-id="2943" fill="#1890ff"></path></svg>)
const AddAndOrLevelIcon = props => <Icon component={addAndOrLevelSvg} {...props} />;

class ConditionsEditor extends React.Component {

    constructor() {
        super();
        this.state = {
            conditions: {}
        }
    }

    render() {
        const isNull = this.state.conditions == null
        return isNull ? <></> : (<Row>
            <Col flex="100%">
                {this.renderNode(0, 0, this.state.conditions)}
            </Col>
        </Row>)
    }

    _getOperators(prop) {
        if (isEmpty(prop)) {
            return []
        }

        let operators = [
            { value: 'EQUAL', label: '等于' },
            { value: 'NOT_EQUAL', label: '不等于' },
            { value: 'IS_NULL', label: '是空值' },
            { value: 'IS_NOT–NULL', label: '不是空值' }
        ]
        
        const comparableOperators = [
            { value: 'GREATER_THAN', label: '大于' },
            { value: 'LESS_THAN', label: '小于' },
        ]

        const likableOperators = [
            { value: 'LIKE', label: '包含' },
            { value: 'NOT_LIKE', label: '不包含' },
        ]   

        const containableOperators = [
            { value: 'CONTAIN', label: '包含' },
            { value: 'NOT_CONTAIN', label: '不包含' },
        ]   

        switch(prop.type) {
            case 'string':
                operators.unshift(...likableOperators)
                break
            case 'number':
            case 'date':
            case 'timestamp':
            case 'timestamp_ms':
                operators.unshift(...comparableOperators)
                break
            case 'enum':
                operators.unshift(...containableOperators)
                break
        }
        return operators
    }

    renderNode(level, index, node, parent) {
        switch (node.type) {
            case 'LOGIC':
                return <Card className={this.props.className}>
                    <Row key={level * 100 + index}>
                        {/* {level === 1 ? null : <Col> <span>按属性筛选：</span> </Col>} */}
                        {(node.nodes !== undefined && node.nodes.length > 1) && <Col>
                            <Radio.Group
                                value={node.logic}
                                defaultValue="OR"
                                size="small"
                                buttonStyle="solid"
                                onChange={({ target: { value } }) => this.setState(({ conditions }) => {
                                    node.logic = value;
                                    return { conditions };
                                }, () => this.props.syncConditions(this.state.conditions))}
                            >
                                <Radio.Button key="OR" value="OR">或</Radio.Button>
                                <Radio.Button key="AND" value="AND">且</Radio.Button>
                            </Radio.Group>
                        </Col>}
                        {level > 0 && this.props.editable && <>
                            <Col flex="4px"></Col>
                            <Col>
                                <Tooltip title="下移一层">
                                    <Button
                                        size="small"
                                        type="link"
                                        onClick={() => this.innerNode(index, node, parent)}
                                        icon={<MenuUnfoldOutlined />}
                                    />
                                </Tooltip>
                            </Col>
                             <Col>
                                <Tooltip title="删除">
                                    <Button
                                        danger
                                        size="small"
                                        type="link"
                                        onClick={() => this.deleteNode(index, node, parent)}
                                        icon={<DeleteOutlined />}
                                    />
                                </Tooltip>
                            </Col>
                        </>}
                        {isNotEmpty(node.error) && <Col>
                            <span style={{ color: 'red' }}>{node.error}</span>
                        </Col>}
                    </Row>
                    <div style={{ height: 6 }}></div>
                    {node.nodes.map((n, i) => this.renderNode(level + 1, i, n, node))}
                </Card>;
            case 'EVE_PROP':
                const selectedProp = this.props.eventProperties.find(t => t.name == node.propName)
                return <>
                    <Row>
                        <Col>
                            <Select className='tmplSelector'
                                value={node.propName}
                                onChange={value => this.setState(({ conditions }) => {
                                    node.propName = value;
                                    const prop = this.props.eventProperties.find(t => t.name == value)
                                    node.propType = prop.type
                                    delete node.rhs;
                                    delete node.error;
                                    return { conditions };
                                }, () => this.props.syncConditions(this.state.conditions))}
                                size="small"
                                placeholder="属性名称"
                                style={{ width: 200 }}
                            >
                                {this.props.eventProperties.map(p =>
                                    <Select.Option key={p.name} value={p.name}>
                                        {p.nameChs}
                                    </Select.Option>)}
                            </Select>
                        </Col>
                        <Col flex="4px"></Col>
                        <Col>
                            <Select className='tmplSelector'
                                value={node.operator}
                                placeholder="逻辑关系"
                                size="small"
                                onChange={value => this.setState(({ conditions }) => {
                                    node.operator = value;
                                    delete node.error;
                                    return { conditions };
                                }, () => this.props.syncConditions(this.state.conditions))}
                                style={{ width: 90 }}
                            >
                                {this._getOperators(selectedProp).map(op => <Select.Option key={op.value} value={op.value}>{op.label}</Select.Option>)}
                            </Select>
                        </Col>
                        <Col flex="4px"></Col>
                        {this.renderNodeRhs(node)}
                        <Col flex="4px"></Col>
                        {this.props.editable && this.renderLastOperators(index, node, parent)}
                        {this.props.editable && <Col>
                            <Button
                                danger
                                size="small"
                                type="link"
                                onClick={() => this.deleteNode(index, node, parent)}
                            >
                                <DeleteOutlined />
                            </Button>
                        </Col>
                        }
                        {isNotEmpty(node.error) && <Col>
                            <span style={{ color: 'red' }}>{node.error}</span>
                        </Col>}
                    </Row>
                    <div style={{ height: 6 }} />
                </>
        }
    }

    renderNodeRhs(node) {
        if (isEmpty(node.operator) || node.operator === 'IS_NULL' || node.operator === 'IS_NOT_NULL' || node.propName === undefined) {
            return <></>
        }
        const prop = this.props.eventProperties.find(p => p.name === node.propName);
        if (prop == null) {
            return <></>
        }
        switch(prop.type) {
            case 'enum': {
                let multiple = false
                if (node.operator === 'CONTAIN' || node.operator === 'NOT_CONTAIN') {
                    multiple = true
                }
                
                return <Select className='tmplSelector'
                    size="small"
                    mode= "multiple"

                    allowClear
                    value={node.rhs}
                    onChange={value => this.setState(({ conditions }) => {
                        // console.info(value)
                        node.rhs = value.length > 0 ? [value[value.length-1]] : value;
                        delete node.error;
                        return { conditions };
                    }, () => this.props.syncConditions(this.state.conditions))}
                    style={{ width: 360 }}
                    placeholder='属性值'
                >
                    {(prop.enumValues || "").split(',').map( item => {
                        return <Select.Option key={item} value={item}> {item} </Select.Option>
                    })}
                </Select>
            }
            case 'date': 
            case 'timestamp':
            case 'timestamp_ms': {
                const showTime = node.type === 'date' ? false : true
                if (node.operator === 'GREATER_THAN' || node.operator === 'LESS_THAN') {
                    return <DatePicker size="small" 
                            showTime={showTime} 
                            locale={locale} 
                            value={node.rhs === undefined ? null : moment(node.rhs[0], dateTimeFormat)}
                            onChange={ datetime => this.setState( ({ conditions }) => {
                                if (datetime == null) {
                                    delete node.rhs
                                } else {
                                    node.rhs = [datetime.format(dateTimeFormat)]
                                    delete node.error
                                }

                                return { conditions }
                        }, () => this.props.syncConditions(this.state.conditions) ) }/>
                } else {
                    return <DatePicker.RangePicker
                            size="small"
                            showTime={showTime}
                            locale={locale}
                            value={node.rhs === undefined ? [] : [
                                moment(node.rhs[0], dateTimeFormat),
                                moment(node.rhs[1], dateTimeFormat),
                            ]}
                            onChange={datetimes => this.setState(({ conditions }) => {
                                if (datetimes === undefined || datetimes === null) {
                                    delete node.rhs;
                                } else {
                                    node.rhs = [datetimes[0].format(dateTimeFormat), datetimes[1].format(dateTimeFormat)]
                                    delete node.error;
                                }
                                return { conditions };
                            }, () => this.props.syncConditions(this.state.conditions))}
                        /> 
                }
            }
            case 'number':
                if (node.operator === 'EQUAL' || node.operator === 'NOT_EQUAL') {
                    return <>
                        <Input 
                            size="small"
                            placeholder='属性值'
                            value={node.rhs === undefined ? undefined : node.rhs[0]}
                            onChange={({ target: { value } }) => this.setState(({ conditions }) => {
                                if (node.rhs === undefined) {
                                    node.rhs = [value, undefined];
                                } else {
                                    node.rhs[0] = value;
                                    delete node.error;
                                }
                                return { conditions };
                            }, () => this.props.syncConditions(this.state.conditions))}
                            style={{ width: 200 }} /> 
                        &nbsp; 至 &nbsp;
                        <Input
                            size="small"
                            placeholder='属性值'
                            value={node.rhs === undefined ? undefined : node.rhs[1]}
                            onChange={({ target: { value } }) => this.setState(({ conditions }) => {
                                if (node.rhs === undefined) {
                                    node.rhs = [value, undefined];
                                } else {
                                    node.rhs[1] = value;
                                    delete node.error;
                                }
                                return { conditions };
                            }, () => this.props.syncConditions(this.state.conditions))}
                            style={{ width: 200 }} /> 
                        </>
                } else {
                    <Input
                        size="small"
                        placeholder='属性值'
                        value={node.rhs === undefined ? undefined : node.rhs[0]}
                        onChange={({ target: { value } }) => this.setState(({ conditions }) => {
                            if (node.rhs === undefined) {
                                node.rhs = [value, undefined];
                            } else {
                                node.rhs[0] = value;
                                delete node.error;
                            }
                            return { conditions };
                        }, () => this.props.syncConditions(this.state.conditions))}
                        style={{ width: 360 }} />
                }
            default: 
                return <Input
                    size="small"
                    placeholder='属性值'
                    value={node.rhs === undefined ? undefined : node.rhs[0]}
                    onChange={({ target: { value } }) => this.setState(({ conditions }) => {
                        if (node.rhs === undefined) {
                            node.rhs = [value, undefined];
                        } else {
                            node.rhs[0] = value;
                            delete node.error;
                        }
                        return { conditions };
                    }, () => this.props.syncConditions(this.state.conditions))}
                    style={{ width: 360 }} />

        }

    }

    renderLastOperators(index, node, parent) {
        if (parent === undefined || index !== parent.nodes.length - 1) {
            return <Col>
                <Tooltip title="下移一层">
                    <Button
                        size="small"
                        type="link"
                        onClick={() => this.innerNode(index, node, parent)}
                        icon={<MenuUnfoldOutlined />}
                    />
                </Tooltip>
            </Col>
        }
        return <>
            <Col>
                <Tooltip title="增加一条规则">
                    <Button
                        size="small"
                        type="link"
                        onClick={() => this.setState(({ conditions }) => {
                            parent.nodes.push({
                                type: 'EVE_PROP'
                            });
                            delete parent.error;
                            return { conditions };
                        }, () => this.props.syncConditions(this.state.conditions))}
                        icon={<PlusOutlined />}
                    />
                </Tooltip>
            </Col>
            {/* <Col>
                <Tooltip title="下移一层">
                    <Button
                        size="small"
                        type="link"
                        onClick={() => this.innerNode(index, node, parent)}
                        icon={<MenuUnfoldOutlined />}
                    />
                </Tooltip>
            </Col> */}
            <Col>
                <Tooltip title="新增组合条件">
                <Button 
                    size="small"
                    type="link"
                    // style={{ color: '#1890ff', borderColor: '#1890ff' }}
                    icon={<AddAndOrLevelIcon />}
                    onClick={() => this.setState(({ conditions }) => {
                        delete parent.error;
                        parent.nodes.push({
                            type: 'LOGIC',
                            logic: 'OR',
                            nodes: [{
                                type: 'EVE_PROP'
                            }]
                        });
                        return { conditions };
                    }, () => this.props.syncConditions(this.state.conditions))}
                />
                </Tooltip>
            </Col>
        </>;
    }

    componentDidMount() {
        console.info(this.props)
        this.setState({ conditions: this.props.conditions });
        this.eventProperties = {};
        this.props.eventProperties.forEach(prop => {
            this.eventProperties[prop.name] = prop;
        });
    }

    innerNode(index, node, parent) {
        //this.deleteNode(index, node, parent);

        this.setState(({ conditions }) => {
            delete parent.error;
            parent.nodes[index] = {
                type: 'LOGIC',
                logic: 'OR',
                nodes: [node]
            };
            return { conditions };
        }, () => this.props.syncConditions(this.state.conditions));
    }

    deleteNode(index, _, parent) {
        if (parent === undefined) {
            return;
        }
        this.setState(({ conditions }) => {
            const nodes = parent.nodes.filter((_, i) => i !== index);
            parent.nodes = nodes;
            if (parent.root && nodes.length === 0) {
                //parent.nodes = [{ type: '' }];
                conditions = null
            }
            return { conditions };
        }, () => this.props.syncConditions(this.state.conditions));
    }
}

export default ConditionsEditor
